import {useEffect, useState} from 'react';
import './styles/Testimonials.css';

type Props = {
    testimonials: {
        rating: number;
        name: string;
        comment: string;
        place: string;
    }[];
};

function TestimonialsSection({ testimonials }: Props) {
    const [startIndex, setStartIndex] = useState(0);



    const next = () => {
        setStartIndex((prev) => (prev + 1) % testimonials.length);
    };

    const previous = () => {
        setStartIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
    };

    const [itemsToShow, setItemsToShow] = useState(3);

    useEffect(() => {
        const updateItemsToShow = () => {
            if (window.innerWidth <= 768) {
                setItemsToShow(1);
            } else if (window.innerWidth <= 1024) {
                setItemsToShow(2);
            } else {
                setItemsToShow(3);
            }
        };

        updateItemsToShow();

        window.addEventListener('resize', updateItemsToShow);

        return () => {
            window.removeEventListener(
                'resize',
                updateItemsToShow
            );
        };
    }, []);

    const arrowsActive =
        testimonials.length > itemsToShow;

    const visibleTestimonials = [];

    const count = Math.min(
        itemsToShow,
        testimonials.length
    );

    for (let i = 0; i < count; i++) {
        visibleTestimonials.push(
            testimonials[(startIndex + i) % testimonials.length]
        );
    }

    return (
        <div >
            <div className="testimonials-title">
                Testimonials
            </div>
            <div className="testimonials-container">
                <div
                    className={`left-arrow ${arrowsActive ? 'active' : ''}`}
                    onClick={arrowsActive ? previous : undefined}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                        <g id="Group_918" data-name="Group 918" transform="translate(-792 -942)">
                            <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" transform="translate(792 942)" fill="#436ab3"/>
                            <path id="Path_14050" data-name="Path 14050" d="M13.25,4.5l-5,5,5,5" transform="translate(792.75 945)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                        </g>
                    </svg>

                </div>

                <div className="testimonials-body">


                    <div className="testimonials-main">
                        {visibleTestimonials.map((testimonial, index) => (
                            <div className="testimonial-card" key={`${testimonial.name}-${startIndex}-${index}`}>
                                <p className='testimonial-comment'>{testimonial.comment}</p>
                                <div className="testimonial-rating">
                                    {Array.from({ length: testimonial.rating }, (_, index) => (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                            <path id="Path_19003" data-name="Path 19003" d="M12.276,3.549a.6.6,0,0,1,1.136,0L15.732,9.4a.618.618,0,0,0,.519.395l6.026.506a.651.651,0,0,1,.351,1.131l-4.591,4.123a.663.663,0,0,0-.2.638l1.4,6.164a.659.659,0,0,1-.236.67.591.591,0,0,1-.681.028l-5.16-3.3a.59.59,0,0,0-.64,0l-5.16,3.3a.591.591,0,0,1-.681-.028.659.659,0,0,1-.236-.67l1.4-6.165a.662.662,0,0,0-.2-.638L3.059,11.432a.663.663,0,0,1-.186-.688A.62.62,0,0,1,3.41,10.3l6.026-.506A.618.618,0,0,0,9.955,9.4l2.321-5.849Z" transform="translate(-2.844 -3.15)" fill="#fff"/>
                                        </svg>
                                    ))}
                                </div>
                                <p className="testimonial-name">{testimonial.name}, {testimonial.place}</p>

                            </div>
                        ))}
                    </div>
                </div>

                <div
                    className={`right-arrow ${arrowsActive ? 'active' : ''}`}
                    onClick={arrowsActive ? next : undefined}
                >
                    <svg id="Group_917" data-name="Group 917" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
                        <circle id="Ellipse_57" data-name="Ellipse 57" cx="12.5" cy="12.5" r="12.5" fill="#436ab3"/>
                        <path id="Path_14050" data-name="Path 14050" d="M8.25,4.5l5,5-5,5" transform="translate(2.75 3)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                    </svg>

                </div>
            </div>

        </div>
    );
}

export default TestimonialsSection;
